// extracted by mini-css-extract-plugin
export var divider = "_3h-0";
export var dividerText = "_3h-2";
export var dividerVertical = "_3h-1";